import React from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ConfigurationContent from './ConfigurationContent';



const ConfigurationPage = () => {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <ConfigurationContent />
        </DashboardLayout>
    )
}

export default ConfigurationPage;